import API from './API.js';
export default class File_settings extends API {
    constructor() {
        super('Library/file_settings');
    }

}
